import { AUTH_API_URL } from '../config/api';

/**
 * URL of a member's profile picture, or null when they have none.
 *
 * `version` is the `profile_picture_version` the API returns (/users/me/,
 * teamspace_members); it changes only when the picture does, so the URL is
 * served with a long-lived cache header.
 */
export const profilePictureUrl = (email, version) => (
  email && version
    ? `${AUTH_API_URL}profile-picture/${encodeURIComponent(email)}/?v=${version}`
    : null
);

/** Up to two initials from a first/last name, for the Avatar fallback. */
export const memberInitials = (firstName, lastName) => (
  `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toUpperCase()
);
